import Rollbar from "rollbar";

const environment = process.env.VIC_ENV ?? "local";

export const rollbarConfig: Rollbar.Configuration = {
	accessToken: process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN_CLIENT,
	environment,
	scrubTelemetryInputs: true,
	captureIp: false,
	captureEmail: false,
};

export const rollbar = new Rollbar(rollbarConfig);
